import { render, staticRenderFns } from "./floorplan.vue?vue&type=template&id=6a1284e4&scoped=true&"
import script from "./floorplan.vue?vue&type=script&lang=js&"
export * from "./floorplan.vue?vue&type=script&lang=js&"
import style0 from "./floorplan.vue?vue&type=style&index=0&id=6a1284e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1284e4",
  null
  
)

export default component.exports